import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { ColumnGroup } from "primereact/columngroup";
import { DataTable } from "primereact/datatable";
import { Row } from "primereact/row";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CardSeplagScrol from "../../../../components/CardSeplag/CardSeplagScrol";
import QuestionarioSeplag from "../../../../components/QuestionarioSeplag";
import Regua2024 from "../../../../components/Regua2024";
import { printToast } from "../../../../config/global";
import { buscaIndicadorPorIdenPtaFiplan, salvarAvaliacaoAcao } from "../../../../service/Rag/AvaliacaoAcao";

import "./style.modules.scss";
import {
  buscaAnaliseAcaoIndicadorByidenPtaMonitoraByidenPtaFiplanIndicador,
  buscarApuracaoByIndenIndicador,
} from "../../../../service/Rag/AvaliacaoPrograma";
const AvaliacaoAcaoRagObjetivo = (props) => {
  let history = useHistory();
  const [campos, setCampos] = useState(JSON.parse(props.questionario));
  const [produtos, setProdutos] = useState(null);
  const [listaIndicadores, setListaIndicadores] = useState();

  const [produtosArray, setProdutorArray] = useState([]);
  const [mediaPercentual2024, setMediaPercentual2024] = useState(0);
  const [mediaPercentual2025, setMediaPercentual2025] = useState(0);
  const [mediaPercentual2026, setMediaPercentual2026] = useState(0);
  const [mediaPercentual2027, setMediaPercentual2027] = useState(0);

  const [mediaRegua, setMediaRegua] = useState(0);
  useEffect(() => {
    if (
      props.dadosItemAcao?.ptaFiplan?.idenPtaFiplan !== null &&
      props.dadosItemAcao.ptaFiplan.idenPtaFiplan !== undefined
    ) {
      buscaIndicadorPorIdenPtaFiplan(props.dadosItemAcao?.ptaFiplan?.idenPtaFiplan).then((res) => {
        const indicadores = res.data;

        Promise.all(
          indicadores.map(async (indicador) => {
            // Primeiro, tenta buscar a apuração
            const apuracaoRes = await buscarApuracaoByIndenIndicador(indicador.indicador.idenIndicador);

            if (apuracaoRes.data) {
              // Se apuração existe, adiciona ao indicador
              return { ...indicador, apuracao: apuracaoRes.data };
            } else {
              // Se apuração for null, busca a análise
              const analiseRes = await buscaAnaliseAcaoIndicadorByidenPtaMonitoraByidenPtaFiplanIndicador(
                props.dadosItemAcao?.idenPtaMonitora,
                indicador.idenPtaFiplanIndicador
              );
              return { ...indicador, analise: analiseRes.data, apuracao: null };
            }
          })
        ).then((resultadosCompletos) => {
          setListaIndicadores(resultadosCompletos);
        });
      });
    }
  }, [props.dadosItemAcao]);

  useEffect(() => {
    let listaProdutors = [];
    produtos != null &&
      produtos.map((produto) => {
        let prod = { idView: null, previstoAtualizado: null, realizado: null, percRealizacao: null };
        prod.descElemento = produto.descElemento + " (" + produto.ptaFiplan.unidadeMedida.siglUnidadeMedida + ")";
        prod.dataInicioPrevisto = produto.dataInicioPrevisto;
        prod.idView = produto.idView;
        prod.qtdeProdutoPrevisto = parseFloat(produto.qtdeProdutoPrevisto.toFixed(2));
        prod.qtdeRealizadoRAG = parseFloat(produto.qtdeRealizadoRAG.toFixed(2));
        prod.PercRealizadoPrevistoAtualizado = parseFloat(
          ((prod.qtdeRealizadoRAG / prod.qtdeProdutoPrevisto) * 100).toFixed(2)
        );
        listaProdutors.push(prod);
      });
    setProdutorArray(listaProdutors);
  }, [produtos]);

  useEffect(() => {
    setProdutos(props.dadosItemAcao?.produtoAcao);
  }, [listaIndicadores]);

  useEffect(() => {
    let mediaRegua =
      parseFloat(mediaPercentual2024) +
      parseFloat(mediaPercentual2025) +
      parseFloat(mediaPercentual2026) +
      parseFloat(mediaPercentual2027);
    //setMediaRegua(parseFloat((mediaRegua / 4).toFixed(2)));
    setMediaRegua(parseFloat(mediaRegua.toFixed(2)));
  }, [mediaPercentual2024, mediaPercentual2025, mediaPercentual2026, mediaPercentual2027]);

  useEffect(() => {
    let mediaAnual24 = 0;
    let mediaAnual25 = 0;
    let mediaAnual26 = 0;
    let mediaAnual27 = 0;
    produtosArray.map((produto) => {
      //console.log("Med2:",produto)
      switch (formatarData(produto.dataInicioPrevisto)) {
        case 2024:
          //mediaAnual24 += parseFloat(produto.PercRealizadoPrevistoAtualizado);
          mediaAnual24 += produto.PercRealizadoPrevistoAtualizado;
          break;
        case 2025:
          mediaAnual25 += produto.PercRealizadoPrevistoAtualizado;
          break;
        case 2026:
          mediaAnual26 += produto.PercRealizadoPrevistoAtualizado;
          break;
        case 2027:
          mediaAnual27 += produto.PercRealizadoPrevistoAtualizado;
          break;
      }
    });
    produtos && setMediaPercentual2024((mediaAnual24 / produtos.length).toFixed(2));
    produtos && setMediaPercentual2025((mediaAnual25 / produtos.length).toFixed(2));
    produtos && setMediaPercentual2026((mediaAnual26 / produtos.length).toFixed(2));
    produtos && setMediaPercentual2027((mediaAnual27 / produtos.length).toFixed(2));
  }, [produtosArray]);

  const voltar = () => {
    history.push({ pathname: "/raglancamentos", state: {} });
  };

  function formatarValor(value) {
    if (value == "0,00") {
      return "-";
    }
    let val = (value / 1).toFixed(2).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }
  const salvar = () => {
    let v_campos = campos.map((questao, i) => {
      if (questao.data == null || questao.data == "") {
        printToast({
          severity: "error",
          summary: "OBRIGATÓRIO",
          detail: `O item ${i + 1} desta tela é de preenchimento obrigatório.`,
        });
        return false;
      } else if (questao.valrRespostaItemQuest !== null || questao.valrRespostaItemQuest !== "") {
        questao.valrRespostaItemQuest = questao.data;
        return { ...questao };
      }
    });

    let codigoItem = campos[0].codigoItemRag;

    salvarAvaliacaoAcao(codigoItem, v_campos).then((res) => {
      props.setCamposQuestionarioObjetivo(JSON.stringify(campos));
      props.aba(true); //Controle para sinalizar que a Aba Identificacao deve realizar a busca do percentual de preenchimento do acao
      printToast({ summary: "Ação Efetuada", detail: "Avaliação do Objetivo salva com sucesso" });
    });
  };

  const formartNumber = ({ value, unidadeMedida }) => {
    if (Number(value) >= 0) {
      if (unidadeMedida === "Percentual") {
        return (
          Number(value).toLocaleString("pt-BR", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) + "%"
        );
      } else {
        return Number(value).toLocaleString("pt-BR", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    }

    return "-";
  };

  // function formatarValor(value) {
  //   if (value == "0,00") {
  //     return "-";
  //   }
  //   return new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 2 }).format(value);
  // }

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Resultados da Ação" colSpan={1} />
        <Column header="2024" colSpan={3} align={"center"} />
        <Column header="2025" colSpan={3} align={"center"} />
        <Column header="2026" colSpan={3} align={"center"} />
        <Column header="2027" colSpan={3} align={"center"} />
      </Row>
      <Row>
        <Column header="Meta Fisica" colSpan={1} />
        <Column header="Previsto Atualizado" />
        <Column header="Realizado" />
        <Column header="% de Realização" />
        <Column header="Previsto Atualizado" />
        <Column header="Realizado" />
        <Column header="% de Realização" />
        <Column header="Previsto Atualizado" />
        <Column header="Realizado" />
        <Column header="% de Realização" />
        <Column header="Previsto Atualizado" />
        <Column header="Realizado" />
        <Column header="% de Realização" />
      </Row>
    </ColumnGroup>
  );

  const headerGroupIndicadores = (
    <ColumnGroup>
      <Row>
        <Column header="Indicadores da Ação" />
        <Column hidden={true} header="Previsto Atualizado" />
        <Column hidden={true} header="Realizado" />
        <Column hidden={true} header="% de Realização" />
        <Column hidden={true} header="Previsto Atualizado" />
        <Column hidden={true} header="Realizado" />
        <Column hidden={true} header="% de Realização" />
        <Column hidden={true} header="Previsto Atualizado" />
        <Column hidden={true} header="Realizado" />
        <Column hidden={true} header="% de Realização" />
        <Column hidden={true} header="Previsto Atualizado" />
        <Column hidden={true} header="Realizado" />
        <Column hidden={true} header="% de Realização" />
      </Row>
    </ColumnGroup>
  );

  const formatarData = (dataString) => {
    if (dataString != null && dataString != undefined) {
      const partes = dataString.split("/");
      const ano = parseInt(partes[2]);
      return ano;
    }
  };

  const headerTemplate = (data) => {
    return (
      <div className="flex align-items-center gap-2">
        <span className="font-bold">{data.lista}</span>
      </div>
    );
  };

  const footerTemplate = (
    <ColumnGroup>
      <Row>
        <Column colSpan={1} footer="Média de desempenho (%)"></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column
          colSpan={1}
          footer={<label>{mediaPercentual2024 !== 0 ? `${formatarValor(mediaPercentual2024)} %` : "0,00 %"}</label>}
          style={{ textAlign: "end" }}
        ></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column
          colSpan={1}
          footer={<label>{mediaPercentual2025 !== 0 ? `${formatarValor(mediaPercentual2025)} %` : "-"}</label>}
          style={{ textAlign: "end" }}
        ></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column
          colSpan={1}
          footer={<label>{mediaPercentual2026 !== 0 ? `${formatarValor(mediaPercentual2026)} %` : "-"}</label>}
          style={{ textAlign: "end" }}
        ></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column colSpan={1} footer={<label>{"-"}</label>}></Column>
        <Column
          colSpan={1}
          footer={<label>{mediaPercentual2027 !== 0 ? `${formatarValor(mediaPercentual2027)} %` : "-"}</label>}
          style={{ textAlign: "end" }}
        ></Column>
      </Row>
    </ColumnGroup>
  );

  /* Template para Produtos Meta Fisica */
  /* Templates 2024 */
  const templatePrevistoAtualizado2024 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2024") {
      return (
        <label>
          {rowData.qtdeProdutoPrevisto != "Infinity" ? formatarValor(rowData.qtdeProdutoPrevisto) : "0,00"}{" "}
        </label>
      );
    } else {
      return <label> </label>;
    }
  };

  const templateRealizado2024 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2024") {
      return (
        <label>{rowData.qtdeRealizadoRAG != "Infinity" ? formatarValor(rowData.qtdeRealizadoRAG) : "0,00"} </label>
      );
    } else {
      return <label> </label>;
    }
  };
  const templatePercRealizacao2024 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2024") {
      return (
        <label>
          {rowData.PercRealizadoPrevistoAtualizado != "Infinity"
            ? formatarValor(rowData.PercRealizadoPrevistoAtualizado)
            : "0,00"}{" "}
          %
        </label>
      );
    } else {
      return <label> </label>;
    }
  };

  /* Templates 2025 */
  const templatePrevistoAtualizado2025 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2025") {
      return <label>{formatarValor(rowData.previstoAtualizado)}</label>;
    } else {
      return <label> </label>;
    }
  };

  const templateRealizado2025 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2025") {
      return <label>{formatarValor(rowData.qtdeProdutoPrevisto)}</label>;
    } else {
      return <label> </label>;
    }
  };
  const templatePercRealizacao2025 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2025") {
      return (
        <label>
          {rowData.PercRealizadoPrevistoAtualizado != "Infinity"
            ? formatarValor(rowData.PercRealizadoPrevistoAtualizado)
            : "0,00"}{" "}
          %
        </label>
      );
    } else {
      return <label> </label>;
    }
  };

  /* Templates 2026 */
  const templatePrevistoAtualizado2026 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2026") {
      return <label>{formatarValor(rowData.previstoAtualizado)}</label>;
    } else {
      return <label> </label>;
    }
  };

  const templateRealizado2026 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2026") {
      return <label>{formatarValor(rowData.qtdeProdutoPrevisto)}</label>;
    } else {
      return <label> </label>;
    }
  };
  const templatePercRealizacao2026 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2026") {
      return (
        <label>
          {rowData.PercRealizadoPrevistoAtualizado != "Infinity"
            ? formatarValor(rowData.PercRealizadoPrevistoAtualizado)
            : "0,00"}{" "}
          %
        </label>
      );
    } else {
      return <label> </label>;
    }
  };

  /* Templates 2027 */
  const templatePrevistoAtualizado2027 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2027") {
      return <label>{formatarValor(rowData.previstoAtualizado)}</label>;
    } else {
      return <label> </label>;
    }
  };

  const templateRealizado2027 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2027") {
      return <label>{formatarValor(rowData.qtdeProdutoPrevisto)}</label>;
    } else {
      return <label> </label>;
    }
  };
  const templatePercRealizacao2027 = (rowData) => {
    let ano = formatarData(rowData.dataInicioPrevisto);

    if (ano == "2027") {
      return (
        <label>
          {rowData.PercRealizadoPrevistoAtualizado != "Infinity"
            ? formatarValor(rowData.PercRealizadoPrevistoAtualizado)
            : "0,00"}{" "}
          %
        </label>
      );
    } else {
      return <label> </label>;
    }
  };

  /* Template para Indicadores */
  /* Templates 2024 */

  const templateIndicadorPrevistoAtualizado2024 = (rowData) => {
    return formartNumber({
      value: rowData.indicador?.valrMetaIndicadorAcao,
      unidadeMedida: rowData.indicador?.unidadeMedida.descUnidadeMedida,
    });
  };

  const templateIndicadorRealizado2024 = (rowData) => {
    return formartNumber({
      value: rowData.apuracao != null ? rowData.apuracao?.valrApurado : rowData.analise?.valrApurado,
      unidadeMedida: null,
    });
  };

  const templateIndicadorPercRealizacao2024 = (rowData) => {
    const total = rowData.indicador?.valrMetaIndicadorAcao;

    const realizado = rowData.apuracao != null ? rowData.apuracao?.valrApurado : rowData.analise?.valrApurado;

    if ((typeof total === "number", typeof realizado === "number")) {
      return formartNumber({
        value: (realizado / total) * 100,
        unidadeMedida: "Percentual",
      });
    }

    return "-";
  };

  /* Templates 2025 */
  const templateIndicadorPrevistoAtualizado2025 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2025") {
      return <label>{"0,00"}</label>;
    } else {
      return <label> </label>;
    }
  };

  const templateIndicadorRealizado2025 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2025") {
      return <label>{"0,00"}</label>;
    } else {
      return <label> </label>;
    }
  };
  const templateIndicadorPercRealizacao2025 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2025") {
      return <label>{"0,00"} %</label>;
    } else {
      return <label> </label>;
    }
  };

  /* Templates 2026 */
  const templateIndicadorPrevistoAtualizado2026 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2026") {
      return <label>{"0,00"}</label>;
    } else {
      return <label> </label>;
    }
  };

  const templateIndicadorRealizado2026 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2026") {
      return <label>{"0,00"}</label>;
    } else {
      return <label> </label>;
    }
  };
  const templateIndicadorPercRealizacao2026 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2026") {
      return <label>{"0,00"} %</label>;
    } else {
      return <label> </label>;
    }
  };

  /* Templates 2027 */
  const templateIndicadorPrevistoAtualizado2027 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2027") {
      return <label>{"0,00"}</label>;
    } else {
      return <label> </label>;
    }
  };

  const templateIndicadorRealizado2027 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2027") {
      return <label>{"0,00"}</label>;
    } else {
      return <label> </label>;
    }
  };
  const templateIndicadorPercRealizacao2027 = (rowData) => {
    let ano = formatarData(rowData.dataAtualizacao);

    if (ano == "2027") {
      return <label>{"0,00"} %</label>;
    } else {
      return <label> </label>;
    }
  };

  return (
    <>
      <CardSeplagScrol>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label style={{ fontSize: "large" }}>
            <b>Objetivo Especifico da Ação: </b>
            {props.dadosItemAcao &&
              (props.dadosItemAcao.ptaFiplan.ptaFiplanDetalhe
                ? props.dadosItemAcao.ptaFiplan.ptaFiplanDetalhe.descObjetivo
                : "")}
          </label>
        </div>
        <div className="tabelaMetaIndicadores" style={{ height: "fit-content", marginBottom: "2%" }}>
          <DataTable
            headerColumnGroup={headerGroup}
            value={produtosArray}
            rowGroupHeaderTemplate={headerTemplate}
            footerColumnGroup={footerTemplate}
            tableStyle={{ minWidth: "50rem", width: "100%" }}
            showGridlines
            emptyMessage={"Sem Dados"}
          >
            <Column
              field="descElemento"
              body={(rowData) => {
                return <label style={{ wordBreak: "break-word" }}>{rowData.descElemento}</label>;
              }}
              header="Meta Fisica"
            />
            <Column header="Previsto Atualizado" body={templatePrevistoAtualizado2024} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="Realizado" body={templateRealizado2024} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="% de Realização" body={templatePercRealizacao2024} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="Previsto Atualizado" body={templatePrevistoAtualizado2025} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="Realizado" body={templateRealizado2025} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="% de Realização" body={templatePercRealizacao2025} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="Previsto Atualizado" body={templatePrevistoAtualizado2026} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="Realizado" body={templateRealizado2026} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="% de Realização" body={templatePercRealizacao2026} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="Previsto Atualizado" body={templatePrevistoAtualizado2027} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="Realizado" body={templateRealizado2027} style={{ textAlign: "end" }}>
              {" "}
            </Column>
            <Column header="% de Realização" body={templatePercRealizacao2027} style={{ textAlign: "end" }}>
              {" "}
            </Column>
          </DataTable>
          <DataTable
            value={listaIndicadores}
            headerColumnGroup={headerGroupIndicadores}
            tableStyle={{ minWidth: "50rem", width: "100%" }}
            showGridlines
            emptyMessage={"Sem Dados de Indicadores"}
          >
            <Column field="indicador.descIndicador" />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPrevistoAtualizado2024}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorRealizado2024}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPercRealizacao2024}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPrevistoAtualizado2025}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorRealizado2025}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPercRealizacao2025}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPrevistoAtualizado2026}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorRealizado2026}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPercRealizacao2026}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPrevistoAtualizado2027}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorRealizado2027}
              style={{ textAlign: "end" }}
            />
            <Column
              field="indicador.valrIndiceRecente"
              body={templateIndicadorPercRealizacao2027}
              style={{ textAlign: "end" }}
            />
          </DataTable>
        </div>
        <div className="ReguaQualidade">
          {/* {console.log("MandouPraRegua:",mediaRegua)}*/}
          {/* <Regua2024 atributos={[{ titulo: "", porcentagemPrevisto: mediaRegua * 4 }]}></Regua2024> */}
          <Regua2024 atributos={[{ titulo: "", porcentagemPrevisto: mediaRegua }]}></Regua2024>
        </div>
        {/* </> } */}
        <QuestionarioSeplag
          campos={campos}
          setCampos={setCampos}
          condicao={props.condicao}
          IsMaximoCaracteres={true}
          qtdMaxCaracteres={10000}
          isDisabled={!props.podeAvaliarAcao}
        ></QuestionarioSeplag>
        <br />
        <br />
      </CardSeplagScrol>
      <div className="p-fluid grid" style={{ marginTop: "5px" }}>
        <div className="field col-12 md:col-8 "></div>
        <div className="field col-12 md:col-2 ">
          <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
        </div>
        <div className="field col-12 md:col-2 ">
          <Button label="Salvar" className="p-button-success" onClick={salvar} disabled={!props.podeAvaliarAcao} />
        </div>
      </div>
    </>
  );
};

export default AvaliacaoAcaoRagObjetivo;
